import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ReadOnlyModeService } from '../../services/read-only/read-only.service';

/**
 * Banner explaining that the session is read-only, so an empty action toolbar
 * reads as a permission state rather than a broken page.
 *
 * Rendered ONCE in the app shell (`app.component.html`, inside `.content-body`
 * above the router outlet), so every routed page gets it automatically -
 * including pages added later. Do not add it to individual page templates; that
 * would show two banners.
 *
 * Collapses to nothing whenever the session may write.
 */
@Component({
  selector: 'app-read-only-banner',
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslateModule],
  template: `
    <div
      *ngIf="readOnlyMode.isReadOnly$ | async"
      class="flex items-center gap-3 rounded-md border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900"
      role="status"
    >
      <mat-icon class="!h-5 !w-5 !text-[20px] shrink-0">visibility</mat-icon>
      <span>
        {{
          (readOnlyMode.reason === 'GLOBAL_READ_ONLY_MODE'
            ? 'readOnlyMode.globalBanner'
            : 'readOnlyMode.banner'
          ) | translate
        }}
      </span>
    </div>
  `,
})
export class ReadOnlyBannerComponent {
  readonly readOnlyMode = inject(ReadOnlyModeService);
}
